import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import moment from "moment";
import 'moment-duration-format';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import ZSearch from '../../../../components/Common/ZSearch';
//import DateRangePicker from '../../../../../components/DateRangePicker/DateRangePicker';
import DateRangePicker from '../../../../components/v3/DateRangePicker/DateRangePicker';
import { formatDate, isDefined, sortReactTable } from '../../../../utils';
import { dateFormat, columnsAccessors, timePeriodicityOptions } from '../../../../constants';

import ExportIcon from '../../../../icons/ExportIcon';
import FilterIcon from '../../../../icons/FilterIcon';
import FilterIconBack from '../../../../icons/FilterIconBack';
import CloseFilterIcon from '../../../../icons/CloseFilterIcon';
import CallChannelIcon from '../../../../icons/CallChannelIcon';
import EmailChannelIcon from '../../../../icons/EmailChannelIcon';
import ChatChannelIcon from '../../../../icons/ChatChannelIcon';
import MinMaxSelectorFilter from '../../../../components/v3/CalibrationScreenV3/MinMaxSelectorFilter';
import PopupCustomized from '../../../../components/PopupCustomized';
import HelpOutline from '@material-ui/icons/HelpOutline';

class TicketsTableForManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTeamFilter: undefined,
            showFiltersHeader: false,

            showAvgBiasFilterPopup: false,
            minAvgBiasFilterValue: undefined,
            maxAvgBiasFilterValue: undefined,

            searchChannelOrInteractionIdQuery: undefined,
            agentNameQuery: undefined,
            searchTeamQuery: undefined,
            rfcQuery: undefined,
            dateTimeQuery: undefined,
            auditedQuery: undefined,
            coachedQuery: undefined,

            questionQueries: {},
            flag: false,
            hoveredRowId: undefined
        };

        this.onSelectNewTimeRange = this.onSelectNewTimeRange.bind(this);

        this.onSearchTeam = this.onSearchTeam.bind(this);
        this.onSelectTeamFilter = this.onSelectTeamFilter.bind(this);
        this.onSearchByChannelOrInteractionId = this.onSearchByChannelOrInteractionId.bind(this);
        this.onSearchByAgentName = this.onSearchByAgentName.bind(this);
        this.onSearchRfc = this.onSearchRfc.bind(this);
        this.onSearchDateTime = this.onSearchDateTime.bind(this);
        this.onSearchAudited = this.onSearchAudited.bind(this);
        this.onSearchCoached = this.onSearchCoached.bind(this);

        this.onSearchQuestionResponse = this.onSearchQuestionResponse.bind(this);

        this.hideFiltersHeader = this.hideFiltersHeader.bind(this);
        this.showFiltersHeader = this.showFiltersHeader.bind(this);

        this.getTableColumns = this.getTableColumns.bind(this);

        this.getSelectedNode = this.getSelectedFilterValuesNode.bind(this);
        this.getMinMaxFiltersHeader = this.getMinMaxFiltersHeader.bind(this);

        this.showAvgBiasFilterPopup = this.showAvgBiasFilterPopup.bind(this);
        this.hideAvgBiasFilterPopup = this.hideAvgBiasFilterPopup.bind(this);
        this.hideAvgBiasFiltersHeader = this.hideAvgBiasFiltersHeader.bind(this);

        this.showAvgBiasVsLastMonthFilterPopup = this.showAvgBiasVsLastMonthFilterPopup.bind(this);
        this.hideAvgBiasVsLastMonthFilterPopup = this.hideAvgBiasVsLastMonthFilterPopup.bind(this);
        this.hideAvgBiasVsLastMonthFiltersHeader = this.hideAvgBiasVsLastMonthFiltersHeader.bind(this);

        this.setHoveredRow = this.setHoveredRow.bind(this);


        this.showAuditedHelpPopup = this.showAuditedHelpPopup.bind(this);
        this.closeAuditedHelpPopup = this.closeAuditedHelpPopup.bind(this);

        this.showCoachedHelpPopup = this.showCoachedHelpPopup.bind(this);
        this.closeCoachedHelpPopup = this.closeCoachedHelpPopup.bind(this);

        this.showJibeIqHelpPopup = this.showJibeIqHelpPopup.bind(this);
        this.closeJibeIqHelpPopup = this.closeJibeIqHelpPopup.bind(this);
    }

    showAuditedHelpPopup(e) {
        this.setState({ showAuditedHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeAuditedHelpPopup() {
        this.setState({ showAuditedHelpPopup: false });
    }

    showCoachedHelpPopup(e) {
        this.setState({ showCoachedHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeCoachedHelpPopup() {
        this.setState({ showCoachedHelpPopup: false });
    }

    showJibeIqHelpPopup(e) {
        this.setState({ showJibeIqHelpPopup: true, mouseClickX: e.clientX, mouseClickY: e.clientY });
    }

    closeJibeIqHelpPopup() {
        this.setState({ showJibeIqHelpPopup: false });
    }

    // Show hide filter functions
    showFiltersHeader() {
        this.setState({ showFiltersHeader: true });
    }

    hideFiltersHeader() {
        this.setState({
            showFiltersHeader: false,
            searchChannelOrInteractionIdQuery: undefined,
            agentNameQuery: undefined,
            rfcQuery: undefined,
            dateTimeQuery: undefined,
            auditedQuery: undefined,
            coachedQuery: undefined,
            searchTeamQuery: undefined,
            questionQueries: {},
            minAvgBiasFilterValue: undefined,
            maxAvgBiasFilterValue: undefined
        });
    }
    //AvgBias
    showAvgBiasFilterPopup() {
        this.setState({
            showAvgBiasFilterPopup: true,
        });
    }

    hideAvgBiasFilterPopup(min, max) {
        this.setState({
            showAvgBiasFilterPopup: false,
            minAvgBiasFilterValue: min,
            maxAvgBiasFilterValue: max
        });
    }

    hideAvgBiasFiltersHeader() {
        this.setState({
            minAvgBiasFilterValue: undefined,
            maxAvgBiasFilterValue: undefined
        });
    }

    //AvgBiasVsLastMonth
    showAvgBiasVsLastMonthFilterPopup() {
        this.setState({
            showAvgBiasVsLastMonthFilterPopup: true,
        });
    }

    hideAvgBiasVsLastMonthFilterPopup(min, max) {
        this.setState({
            showAvgBiasVsLastMonthFilterPopup: false,
            minAvgBiasVsLastMonthFilterValue: min,
            maxAvgBiasVsLastMonthFilterValue: max
        });
    }

    hideAvgBiasVsLastMonthFiltersHeader() {
        this.setState({
            minAvgBiasVsLastMonthFilterValue: undefined,
            maxAvgBiasVsLastMonthFilterValue: undefined
        });
    }

    ////////////////////////////////////////////////////

    onSearchTeam({ target }) {
        this.setState({ searchTeamQuery: target.value });
    }

    onSearchByChannelOrInteractionId({ target }) {
        this.setState({ searchChannelOrInteractionIdQuery: target.value });
    }

    onSearchByAgentName({ target }) {
        this.setState({ agentNameQuery: target.value });
    }

    onSearchRfc({ target }) {
        this.setState({ rfcQuery: target.value });
    }

    onSearchDateTime({ target }) {
        this.setState({ dateTimeQuery: target.value });
    }

    onSearchAudited({ target }) {
        this.setState({ auditedQuery: target.value });
    }

    onSearchCoached({ target }) {
        this.setState({ coachedQuery: target.value });
    }

    onSearchQuestionResponse({ target }, sqShortName) {
        this.state.questionQueries[sqShortName] = target.value;
        this.setState({ flag: !this.state.flag });
    }

    onSelectTeamFilter({ currentTarget }) {
        const
            {
                interactionFilters,
            } = this.props;
        if (!currentTarget || !currentTarget.options || typeof currentTarget.options.selectedIndex === 'undefined'
            || !interactionFilters || !Array.isArray(interactionFilters))
            return;

        let selectedTeamFilter = interactionFilters[currentTarget.options.selectedIndex];
        this.setState({ selectedTeamFilter });
    }

    getSelectedFilterValuesNode(key, value, onClick) {
        return (
            <div className="selected-node" style={{ padding: '0 20px' }} key={key}>
                <HighlightOffIcon onClick={() => onClick(key)} style={{ margin: '0 10px 0 -5px', color: '#98DDE1' }} />
                {value}
            </div>);
    }

    getMinMaxFiltersHeader(minValue, maxValue, closeFunc) {
        let header;
        if (isDefined(maxValue) && maxValue != '' &&
            isDefined(minValue) && minValue != '') {
            header = this.getSelectedFilterValuesNode(1, `${minValue} to ${maxValue}`, closeFunc);
        }
        else if (isDefined(minValue) && minValue != '') {
            header = this.getSelectedFilterValuesNode(1, `Min: ${minValue}`, closeFunc);
        }
        else if (isDefined(maxValue) && maxValue != '') {
            header = this.getSelectedFilterValuesNode(1, `Max: ${maxValue}`, closeFunc);
        }
        return header;
    }

    getDateFiltersNode() {
        const {
            fromDate,
            toDate,
        } = this.props;

        return (
            <div className="flex-container">
                <div className="flex-container-start">
                    <DateRangePicker
                        fromDate={fromDate}
                        toDate={toDate}
                        onClose={this.onSelectNewTimeRange} />
                </div>
            </div>);
    }

    //getDateFiltersNode() {
    //    const fromDate = moment().subtract(7, 'd');
    //    const toDate = moment();

    //    const options = [
    //        <option key="1" value="LastWeek">Last Week</option>,
    //        <option key="2" value="LastMonth">Last Month</option>
    //    ];

    //    const length = options.length;
    //    return (
    //        <div style={{ float: 'right' }}>
    //            <div className="vertical-select" style={{ float: 'left' }}>
    //                <select size={length} onChange={this.onSelectDateRange} defaultValue={'LastWeek'} >
    //                    {options}
    //                </select>
    //            </div>
    //            <div style={{ padding: '20px', width: '200px', float: 'right' }} >
    //                <DateRangePicker
    //                    fromDate={fromDate}
    //                    toDate={toDate}
    //                    onClose={this.setNewTimeRangeForProgressOverTime} />
    //            </div>
    //        </div>);
    //}

    getTableColumns() {
        const
            {
                calibratedOnSurveyQuestions,
                isQaTickets
            } = this.props;
        let nameHeader = 'Agent Name';
        let teamHeader = 'Team';
        let interactionHeader = 'Interaction';
        let rfcHeader = 'RFC';
        let dateTimeHeader = 'Date-Time';

        let auditedHeader =
            (<div className="flex-container-center">
                <div>Audited</div>
                {/*<HelpOutline onClick={this.showAuditedHelpPopup}*/}
                {/*    style={{ fontSize: '20px', marginBottom: '6px' }} />*/}
            </div>);

        let coachedHeader =
            (<div className="flex-container-center">
                <div>Coached</div>
                {/*<HelpOutline onClick={this.showCoachedHelpPopup}*/}
                {/*    style={{ fontSize: '20px', marginBottom: '6px' }} />*/}
            </div>);

        if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
            calibratedOnSurveyQuestions.forEach(sq => {
                sq.tableHeader = `${sq.shortName}`;
            });
        }

        if (this.state.showFiltersHeader) {
            interactionHeader = (<ZSearch placeHolder="Interaction Id or Channel" searchValue={this.state.searchChannelOrInteractionIdQuery} onChange={this.onSearchByChannelOrInteractionId} />);
            nameHeader = (<ZSearch placeHolder="Agent Name" searchValue={this.state.agentNameQuery} onChange={this.onSearchByAgentName} />);
            teamHeader = (<ZSearch placeHolder="Team" searchValue={this.state.searchTeamQuery} onChange={this.onSearchTeam} />);
            rfcHeader = (<ZSearch placeHolder="Reason For Contact" searchValue={this.state.rfcQuery} onChange={this.onSearchRfc} />);
            dateTimeHeader = (<ZSearch placeHolder="Date time" searchValue={this.state.dateTimeQuery} onChange={this.onSearchDateTime} />);
            auditedHeader = (<ZSearch placeHolder="Audited" searchValue={this.state.auditedQuery} onChange={this.onSearchAudited} />);
            coachedHeader = (<ZSearch placeHolder="Coached" searchValue={this.state.coachedQuery} onChange={this.onSearchCoached} />);

            if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
                calibratedOnSurveyQuestions.forEach(sq => {
                    sq.tableHeader = (<ZSearch placeHolder={sq.shortName} searchValue={this.state.questionQueries[sq.shortName]}
                        onChange={(event) => this.onSearchQuestionResponse(event, sq.shortName)} />);
                });
            }
        }

        const interactionColumn =
        {
            Header: interactionHeader,
            accessor: columnsAccessors.interactionExternalIdNode
        };

        const nameColumn = {
            Header: nameHeader,
            accessor: columnsAccessors.agentName,
        };

        const agentTeamColumn = {
            Header: teamHeader,
            accessor: columnsAccessors.agentTeam,
        };

        const columns = [interactionColumn, nameColumn, agentTeamColumn];

        if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
            calibratedOnSurveyQuestions.forEach(sq => {
                columns.push(
                    {
                        Header: sq.tableHeader,
                        accessor: `${sq.internalName}Answers`,
                        width: 180
                    }
                );
            });
        }

        columns.push(
            {
                Header: dateTimeHeader,
                accessor: 'startDateFormatted'
            });
        columns.push(
            {
                Header: rfcHeader,
                accessor: columnsAccessors.reasonForContact
            });
        columns.push(
            {
                Header: 'Handle Time (s)',
                accessor: 'totalTimeSpentInSecond'
            });

        if (isQaTickets === true) {

            let jibeIqHeader =
                (<div className="flex-container-center">
                    <div>JibeIQ</div>
                    {/*<HelpOutline onClick={this.showJibeIqHelpPopup}*/}
                    {/*    style={{ fontSize: '20px', marginBottom: '6px' }} />*/}
                </div>);

            columns.push(
                {
                    Header: auditedHeader,
                    accessor: 'auditedPast30DaysToShow'
                });
            columns.push(
                {
                    Header: coachedHeader,
                    accessor: 'coachedPast30DaysToShow'
                });
            //columns.push(
            //    {
            //        Header: jibeIqHeader,
            //        accessor: 'jibeIQScore'
            //    });

            columns.push(
                {
                    Header: 'Coaching Action',
                    accessor: 'coachingAction'
                });
        }
        columns.push(
            {
                Header: ' ',
                accessor: columnsAccessors.k,
                width: 60
            });
        return columns;
    }

    onSelectNewTimeRange(fromDate, toDate) {
        const {
            onSelectNewTimeRange
        } = this.props;
        onSelectNewTimeRange(fromDate, toDate);
    }

    setHoveredRow(hoveredRowId) {
        this.setState({ hoveredRowId: hoveredRowId });
    }

    render() {
        const
            {
                calibratedOnSurveyQuestions,
                interactionFilters,
                interactionToShow,
                allInteractionCount,
                onClick,
                isQaTickets,
                goToAudit,
                onDownloadReport
            } = this.props;

        let result = {};
        result.columns = this.getTableColumns();
        const dateFiltersNode = this.getDateFiltersNode();

        const auditedHelpText = "Audited in past 30 days.";
        const coachedHelpText = "Coached in past 30 days.";
        const jibeIqHelpText = "JibeIQ is an AI powered quotient that automatically identifies the most important interactions for coaching. The higher the JibeIQ score, the more important it is for your team to audit and coach.";

        const loading = !interactionToShow || !Array.isArray(interactionToShow);
        if (loading === true) {
            return (
                <div>
                    <div className="teams-table-for-manager filters-wrapper" style={{ margin: '20px 0' }}>
                        <div className="teams-table-for-manager filter-area-title-wrapper">
                            <label className="teams-table-for-manager all-teams-title">Tickets</label>
                            <label className="teams-table-for-manager number-of-teams-title">{numberOfInteractionsLabel}</label>
                        </div>
                        {dateFiltersNode}
                    </div>
                    <ReactTable
                        columns={result.columns}
                        defaultPageSize={10}
                        loading={loading}
                        className="-striped -highlight" />
                </div>);
        }

        let numberOfInteractionsLabel = '';
        if (isDefined(interactionToShow)) {
            let ofAllTicketCount = '';
            if (isDefined(allInteractionCount) && allInteractionCount !== interactionToShow.length) {
                ofAllTicketCount = `of ${allInteractionCount}`;
            }
            numberOfInteractionsLabel = `(${interactionToShow.length} tickets ${ofAllTicketCount})`
        }

        result.data = interactionToShow;

        ////filter by pre-defined team filters
        //if (isDefined(this.state.selectedTeamFilter) && this.state.selectedTeamFilter.filterName !== 'All') {
        //    result.data = result.data.filter(a => this.state.selectedTeamFilter.teamIds.includes(a.id));
        //}

        //Filter by channel and ticketId
        if (isDefined(this.state.searchChannelOrInteractionIdQuery) && this.state.searchChannelOrInteractionIdQuery != '') {
            result.data = result.data.filter(a => (isDefined(a.channelType) && a.channelType.toLowerCase().includes(this.state.searchChannelOrInteractionIdQuery.toLowerCase()))
                || (isDefined(a.externalNumber) && a.externalNumber.toLowerCase().includes(this.state.searchChannelOrInteractionIdQuery.toLowerCase())));
        }

        //Filter by agent name
        if (isDefined(this.state.agentNameQuery) && this.state.agentNameQuery != '') {
            result.data = result.data.filter(a => (isDefined(a.agentName) && a.agentName.toLowerCase().includes(this.state.agentNameQuery.toLowerCase())));
        }

        //Filter by team
        if (isDefined(this.state.searchTeamQuery) && this.state.searchTeamQuery != '') {
            result.data = result.data.filter(a => (isDefined(a.agentTeam) && a.agentTeam.toLowerCase().includes(this.state.searchTeamQuery.toLowerCase())));
        }

        //Filter by rfc
        if (isDefined(this.state.rfcQuery) && this.state.rfcQuery != '') {
            result.data = result.data.filter(a => (isDefined(a.reasonForContact) && a.reasonForContact.toLowerCase().includes(this.state.rfcQuery.toLowerCase())));
        }

        //Filter by dateTime
        if (isDefined(this.state.dateTimeQuery) && this.state.dateTimeQuery != '') {
            result.data = result.data.filter(a => (isDefined(a.externalOpenDate) && formatDate(a.externalOpenDate).includes(this.state.dateTimeQuery)));
        }

        //Filter by audited
        if (isDefined(this.state.auditedQuery) && this.state.auditedQuery != '') {
            result.data = result.data.filter(a => (isDefined(a.auditedPast30DaysToShow) && a.auditedPast30DaysToShow.toLowerCase().includes(this.state.auditedQuery.toLowerCase())));
        }

        //Filter by coached
        if (isDefined(this.state.coachedQuery) && this.state.coachedQuery != '') {
            result.data = result.data.filter(a => (isDefined(a.coachedPast30DaysToShow) && a.coachedPast30DaysToShow.toLowerCase().includes(this.state.coachedQuery.toLowerCase())));
        }

        if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
            calibratedOnSurveyQuestions.forEach(sq => {
                if (isDefined(this.state.questionQueries[sq.shortName]) && this.state.questionQueries[sq.shortName] != '') {

                    if (isQaTickets === true) {
                        result.data = result.data.filter(a =>
                        (isDefined(a[`${sq.internalName}`])
                            && a[`${sq.internalName}`].toLowerCase().includes(this.state.questionQueries[sq.shortName].toLowerCase())));
                    }
                    else {
                        result.data = result.data.filter(a =>
                            ((isDefined(a[`${sq.internalName}AgentPrediction`])
                                && a[`${sq.internalName}AgentPrediction`].toLowerCase().includes(this.state.questionQueries[sq.shortName].toLowerCase())))
                            ||
                            ((isDefined(a[`${sq.internalName}CustomerResponse`])
                                && a[`${sq.internalName}CustomerResponse`].toLowerCase().includes(this.state.questionQueries[sq.shortName].toLowerCase())))
                        );
                    }
                }
            });
        }

        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {

                if (calibratedOnSurveyQuestions && Array.isArray(calibratedOnSurveyQuestions)) {
                    calibratedOnSurveyQuestions.forEach(sq => {
                        if (isQaTickets === true) {
                            row[`${sq.internalName}Answers`] = <div>
                                {row[`${sq.internalName}`]}
                            </div>;
                        }
                        else {
                            const agentAns = row[`${sq.internalName}AgentPrediction`]
                                ? <div>
                                    <span className="agent-or-customer-response-indicator">A</span>
                                    {row[`${sq.internalName}AgentPrediction`]}</div> : undefined;
                            const customerAns = row[`${sq.internalName}CustomerResponse`]
                                ? <div><span className="agent-or-customer-response-indicator">C</span>{row[`${sq.internalName}CustomerResponse`]}</div> : undefined;

                            row[`${sq.internalName}Answers`] = <div>
                                {agentAns}
                                {customerAns}
                            </div>;
                        }

                    });
                }

                if (isDefined(row.auditedPast30Days)) {
                    row.auditedPast30DaysToShow = row.auditedPast30Days ? 'Yes' : 'No'
                }

                if (isDefined(row.coachedPast30Days)) {
                    row.coachedPast30DaysToShow = row.coachedPast30Days ? 'Yes' : 'No'
                }

                if (isDefined(row.externalNumber)) {
                    let channelIcon;
                    if (isDefined(row.channelType)) {
                        if (row.channelType.toLowerCase() == 'voice' || row.channelType.toLowerCase() == 'phone') {
                            channelIcon = <CallChannelIcon />
                        }
                        else if (row.channelType.toLowerCase() == 'chat') {
                            channelIcon = <ChatChannelIcon />
                        }
                        else if (row.channelType.toLowerCase() == 'email') {
                            channelIcon = <EmailChannelIcon />
                        }
                        else {
                            channelIcon = <div className="icon-square">{row.channelType}</div>
                        }
                    }
                    else {
                        channelIcon = <div className="icon-square">--</div>
                    }
                    row.interactionExternalIdNode =
                        (<div className="flex-container-center">
                            <div style={{ minWidth: '20px' }}>
                                {channelIcon}
                            </div>
                            <div style={{ margin: "0 0 0 10px" }}>{row.externalNumber}</div>
                        </div>)
                }

                if (isDefined(row.externalOpenDate)) {
                    row.startDateFormatted = formatDate(row.externalOpenDate);
                }

                if (isQaTickets === true) {
                    row.coachingAction = '';
                    if (row.zacousticTicketId === this.state.hoveredRowId) {
                        row.coachingAction = <div className="v3-button agent-view-interactions"
                            style={{ width: '80px', background: '#32A6AE' }}
                            onClick={() => goToAudit(row)}>
                            Audit
                        </div>
                    }
                }
            });
        }

        const teamsResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className="interactions -striped -highlight"
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onMouseEnter: () => {
                            this.setHoveredRow(rowInfo.original.zacousticTicketId)
                        },
                        onMouseLeave: () => {
                            this.setHoveredRow(null)
                        },
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        if (interactionFilters && Array.isArray(interactionFilters)) {
            const options = interactionFilters.map(t => (<option value={t.filterName} key={t.filterName}>{t.filterName}</option>));
            const length = options.length;
            interactionFiltersNode = (<div className="vertical-select">
                <select size={length} onChange={this.onSelectTeamFilter} defaultValue={'All'}>
                    {options}
                </select>
            </div>)
        }

        return (
            <div>
                <div className="teams-table-for-manager filters-wrapper" style={{ margin: '20px 0' }}>
                    <div className="teams-table-for-manager filter-area-title-wrapper">
                        <label className="teams-table-for-manager all-teams-title">Tickets</label>
                        <label className="teams-table-for-manager number-of-teams-title">{numberOfInteractionsLabel}</label>
                    </div>
                    {!isQaTickets &&
                        <div className="export-button" onClick={() => onDownloadReport()}>
                            <div class="export-button-text">Export</div>
                            <ExportIcon />
                        </div>}
                    {dateFiltersNode}
                </div>
                <div style={{ position: 'relative', zIndex: 0 }}>
                    {!this.state.showFiltersHeader &&
                        <div onClick={this.showFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 2,
                            right: '0',
                            cursor: 'pointer'
                        }}>
                            <FilterIconBack />
                        </div>}
                    {!this.state.showFiltersHeader &&
                        <div onClick={this.showFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 3,
                            right: '0',
                            cursor: 'pointer'
                        }}>
                            <FilterIcon />
                        </div>}

                    {this.state.showFiltersHeader &&
                        <div onClick={this.hideFiltersHeader} style={{
                            position: 'absolute',
                            zIndex: 2,
                            right: '9px',
                            top: '9px',
                            cursor: 'pointer'
                        }}>
                            <CloseFilterIcon />
                        </div>}
                    {teamsResultTable}
                    {this.state.showAvgBiasFilterPopup &&
                        (<MinMaxSelectorFilter
                            title="AVG Bias(%)"
                            onClose={this.hideAvgBiasFilterPopup} />)}
                    {this.state.showAvgBiasVsLastMonthFilterPopup &&
                        (<MinMaxSelectorFilter
                            title="Bias vs. Last Month"
                            onClose={this.hideAvgBiasVsLastMonthFilterPopup} />)}
                    {
                        this.state.showAuditedHelpPopup &&
                        <PopupCustomized
                            x={this.state.mouseClickX}
                            y={this.state.mouseClickY}
                            Message={auditedHelpText}
                            close={this.closeAuditedHelpPopup} />
                    }
                    {
                        this.state.showCoachedHelpPopup &&
                        <PopupCustomized
                            x={this.state.mouseClickX}
                            y={this.state.mouseClickY}
                            Message={coachedHelpText}
                            close={this.closeCoachedHelpPopup} />
                    }
                    {
                        this.state.showJibeIqHelpPopup &&
                        <PopupCustomized
                            x={this.state.mouseClickX}
                            y={this.state.mouseClickY}
                            Message={jibeIqHelpText}
                            close={this.closeJibeIqHelpPopup} />
                    }
                </div>
            </div >);
    };
}

const select = state => ({});
export default connect(select)(TicketsTableForManager);

